module.exports = __webpack_public_path__ + "img/OverseaMember42.99c5237c.jpg";